import { MrAdvancedSearchLayoutConfig } from '@net7/boilerplate-muruca';
import { TtAdvancedSearchLayoutDS } from './tt-advanced-search-layout.ds';

export const TtAdvancedSearchLayoutConfig = {
  ...MrAdvancedSearchLayoutConfig,
  layoutDS: TtAdvancedSearchLayoutDS
};
